import { LinkButton } from "../components/Buttons.js";
import frameImage from "./Frame.png";
const MainSection = () => {
  return (
    <section id="main">
      <header>
        <h1>LionTravelers</h1>
        <p>
          Lion Travelers are unique maned and tailed adventurers with hundreds
          of native elements dropped along their journeys around the world.{" "}
          <br />
          In the near future they will be able to further expand their
          exploration to new dimensions via mysterious wormholes...
          <br />
        </p>
        <LinkButton
          classname="btn primary-button"
          link="#collection"
          text="View Collection"
          target=""
        />
      </header>
      <div className="lion-div">
        <img
          className="lion-main"
          src={frameImage}
          loading="lazy"
          alt="Lion Travelers NFT Collection - Unique lions and lionesses traveling in lands - REEF"
        />
      </div>
    </section>
  );
};

export default MainSection;
